import { createStateContext } from '@change-corgi/core-react/context';

import { INITIAL_STATE } from './initialState';
import { mutations } from './mutations';
import type { PetitionActionsPageState } from './types';

/** @knip-ignore */
export const {
	StateContext: PetitionActionsPageStateContext,
	StateProvider: PetitionActionsPageStateContextProvider,
	useStateContext: usePetitionActionsPageState,
} = createStateContext<
	PetitionActionsPageState,
	typeof mutations,
	{
		isLastSupporterVoicesPage: PetitionActionsPageState['isLastSupporterVoicesPage'];
		isLoadingMoreSupporterVoices: PetitionActionsPageState['isLoadingMoreSupporterVoices'];
		shouldDisplaySupporterVoicesVideo: PetitionActionsPageState['shouldDisplaySupporterVoicesVideo'];
	}
>({
	name: 'PetitionActionsPageStateContext',
	mutations,
	initialState({ isLastSupporterVoicesPage, isLoadingMoreSupporterVoices, shouldDisplaySupporterVoicesVideo }) {
		return {
			...INITIAL_STATE,
			isLastSupporterVoicesPage,
			isLoadingMoreSupporterVoices,
			shouldDisplaySupporterVoicesVideo,
		};
	},
});
